import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertsCountDetails } from '../services/getalertCountService'

export interface AlertsCountDataState {
  isLoading: boolean
  loadingError: string | undefined
  AlertsCountDetailsData: AlertsCountDetails | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: AlertsCountDataState = {
  isLoading: false,
  loadingError: undefined,
  AlertsCountDetailsData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const AlertsCountDetailsDataListState = createSlice({
  name: 'AlertsCountDetailsData',
  initialState,
  reducers: {
    AlertsCountDetailsLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        AlertsCountDetailsData: undefined,
        httpStatus: 0
      }
    },
    AlertsCountDetailsUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        AlertsCountDetailsData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertsCountDetailsErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        AlertsCountDetailsData: undefined
      }
    }
  }
})

// Actions to export
export const {
  AlertsCountDetailsLoadingAction,
  AlertsCountDetailsUpdateAction,
  AlertsCountDetailsErrorAction
} = AlertsCountDetailsDataListState.actions

export default AlertsCountDetailsDataListState.reducer
